import React from 'react'

import { BodyText, MessagePanel, Label } from '@pb/components'

const EmptyMessages: React.FC = () => (
  <MessagePanel title={<Label copyKey="omni.myaccount.inbox.optedin.no.messages.heading" />}>
    <BodyText>
      <Label copyKey="omni.myaccount.inbox.optedin.no.messages.explanation.part1" />
    </BodyText>
    <BodyText>
      <Label copyKey="omni.myaccount.inbox.optedin.no.messages.explanation.part2" />
    </BodyText>
  </MessagePanel>
)

export default EmptyMessages
